import { Component, Input } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MediaService } from '../../_core/services/media.service';
import { ToastService } from '../../_core/services/toast.service';
import { Match } from '../../_shared/models/match.model';

@Component({
  standalone: false,
    selector: 'app-add-media',
    templateUrl: './add-media.component.html',
    styleUrls: ['./add-media.component.scss'],
})
export class AddMediaComponent {
    @Input() match: Match;
    @Input() type = 'item';

    private readonly destroy$: Subject<void> = new Subject();

    constructor(
        private alertController: AlertController,
        private mediaService: MediaService,
        private toast: ToastService
    ) { }

    updateMedia() {
        if (this.match.dist.media?.length) {
            this.removeMedia();
        } else {
            this.addMedia();
        }
    }

    private async removeMedia() {
        const alert = await this.alertController.create({
            header: 'Remove media',
            message: 'Are you sure that you want to remove youtube video',
            buttons: [
                {
                    text: 'Yes, remove',
                    handler: (data) => {
                        this.mediaService
                            .removeMedia(this.match._id, this.match.dist.media[0].mediaId)
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(
                                res => {
                                    this.match.dist.media.splice(0, 1);
                                    this.mediaService.publishMediaUpdate(this.match._id, this.match.dist.media);
                                    this.toast.presentToast('Video is removed');
                                },
                                err => {
                                    //console.log(err)
                                }
                            );
                    }
                },
                {
                    text: 'Close',
                    role: 'cancel'
                }
            ]
        });

        await alert.present();
    }

    private async addMedia() {
        const alert = await this.alertController.create({
            header: 'Add media',
            message: 'Add youtube link for live streaming or match recording',
            inputs: [
                {
                    name: 'url',
                    type: 'text',
                    placeholder: 'Youtube link'
                }
            ],
            buttons: [
                {
                    text: 'Add',
                    handler: (data) => {
                        this.mediaService
                            .addMedia(this.match._id, 'youtube', data.url)
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(
                                res => {
                                    const media = res.data;
                                    this.match.dist.media = media;
                                    this.mediaService.publishMediaUpdate(this.match._id, this.match.dist.media);
                                    this.toast.presentToast('Media is updated');
                                },
                                err => {
                                    //console.log(err)
                                }
                            );
                    }
                },
                {
                    text: 'Close',
                    role: 'cancel'
                }
            ]
        });

        await alert.present();
    }
}
